import { Box } from '@unifyapps/ui/components/Box';
import { Stack } from '@unifyapps/ui/components/Stack';
import type { TooltipProps } from '@unifyapps/ui/components/Tooltip';
import { Tooltip, TooltipModes } from '@unifyapps/ui/components/Tooltip';
import { Typography } from '@unifyapps/ui/components/Typography';

const getTitleNode = ({
  title,
  shortcutKeys,
  mode,
}: {
  title: string;
  shortcutKeys?: string;
  mode?: TooltipProps['mode'];
}) => {
  // The color scheme for the titleNode should be reverse of the mode of the tooltip
  // oxlint-disable-next-line no-nested-ternary
  const adaptedMode = mode
    ? mode === TooltipModes.DARK
      ? TooltipModes.LIGHT
      : TooltipModes.DARK
    : undefined;

  const isSingleKey = shortcutKeys?.length === 1;

  return (
    <Stack
      className="gap-md items-center"
      data-color-scheme={adaptedMode ?? 'dark'}
      direction="row"
    >
      <Typography color="text-primary" variant="text-xs">
        {title}
      </Typography>
      {shortcutKeys ? (
        <Box
          className="border-primary px-xs py-xxs rounded-xs flex items-center justify-center border"
          data-color-scheme={adaptedMode ?? 'dark'}
        >
          <Typography
            className={`text-secondary leading-none ${isSingleKey ? 'tracking-normal' : 'tracking-[2px]'}`}
            variant="text-xxs"
          >
            {shortcutKeys}
          </Typography>
        </Box>
      ) : null}
    </Stack>
  );
};

function TooltipWithShortcut({
  children,
  title,
  shortcutKeys,
  mode,
  ...rest
}: Omit<TooltipProps, 'title'> & {
  shortcutKeys?: string;
  title: string;
}) {
  return (
    <Tooltip mode={mode} titleNode={getTitleNode({ title, shortcutKeys, mode })} {...rest}>
      {children}
    </Tooltip>
  );
}

export default TooltipWithShortcut;
